import { PA_NAME } from "../types/product-attribute/product-attribute";
import { ProdAttrUtils } from "../utils/productAttributeUtils";
import { useProdaName } from "./useProdaName";

export const usePriceItDisplay = () => {
  const { prodaName } = useProdaName();

  const singleHandle = (priceIt: PriceItemDp) => {
    // console.log("priceIt", priceIt);
    const label =
      (function () {
        return (
          prodaName({
            name: priceIt.name as ProdAttrName,
            value: priceIt.paValue,
          }) || priceIt.name
        );
      })() + (priceIt.quantity ? " x " + priceIt.quantity : "");
    const key = priceIt.name;
    const actualAmount = priceIt.actualAmount;
    return {
      label,
      key,
      actualAmount,
      originalAmount:
        priceIt.actualAmount + (priceIt.actualDiscountAmount ?? 0),
      discountAmount: priceIt.actualDiscountAmount,
      priceIt,
    };
  };

  const dp = ({ priceIts }: { priceIts: PriceItemDp[] }) => {
    return priceIts
      .sort((a, b) => {
        const f = (name: string) => {
          if (name.startsWith("CHILD")) {
            const { ageFrom } = ProdAttrUtils.CHILD.parseAge(name);
            return 200 + ageFrom;
          }

          if (
            PA_NAME.VISIBLE_CHECKBOX.includes(
              name as ProdAttrNameSingleCheckbox,
            )
          ) {
            return 900;
          }

          switch (name) {
            case "ADULT":
              return 100;
            case "TOUR_ROOM_ADULT_MAX_FEE_TOTAL":
              return 199;
            case "CHILD":
              return 200;
            case "TOUR_ROOM_CHILD_MAX_FEE_TOTAL":
              return 299;
            case "PERSON":
              return 300;
            case "ROOM":
              return 400;
            case "Q_SIM":
              return 500;
            default:
              return 1000;
          }
        };
        return f(a.name) - f(b.name);
      })
      .map(singleHandle);
  };
  return { dp };
};
